/**
 * Rustik Ray Sistemi Fiyat Matrisleri — 2026
 * Alış fiyatlarına %100 kar marjı uygulanmıştır (satış = alış × 2)
 */

// ─── KANALLI RUSTİK — Birim Fiyatlar ──────────────────────────────────────────
export const KANALLI_ALIS_BIRIM = {
  boruPerMt:  200,
  tekliAyak:  200,
  ciftliAyak: 230,
  baslik:     195,
  tapa:        90,
};

export const KANALLI_SATIS_BIRIM = {
  boruPerMt:  400,
  tekliAyak:  400,
  ciftliAyak: 460,
  baslik:     390,
  tapa:       180,
};

export const AK_CESITLERI = ["AK 1", "AK 2", "AK 3", "AK 4", "AK 5", "AK 6", "AK 7"];

export function suggestAyakAdet(widthCm) {
  const w = Number(widthCm) || 0;
  if (w <= 150) return 2;
  if (w <= 225) return 3;
  if (w <= 325) return 4;
  return 5;
}

export function computeKanallıTotal(widthCm, ayakTipi, ayakAdet, baslikAdet, tapaAdet) {
  const mt = (Number(widthCm) || 0) / 100;
  const boruTL    = Math.round(mt * KANALLI_SATIS_BIRIM.boruPerMt);
  const ayakBirim = ayakTipi === "ciftli" ? KANALLI_SATIS_BIRIM.ciftliAyak : KANALLI_SATIS_BIRIM.tekliAyak;
  const ayakTL    = (Number(ayakAdet)  || 0) * ayakBirim;
  const baslikTL  = (Number(baslikAdet)|| 0) * KANALLI_SATIS_BIRIM.baslik;
  const tapaTL    = (Number(tapaAdet)  || 0) * KANALLI_SATIS_BIRIM.tapa;
  return { boruTL, ayakTL, baslikTL, tapaTL, total: boruTL + ayakTL + baslikTL + tapaTL, mt };
}

// ─── AHŞAP RUSTİK ─────────────────────────────────────────────────────────────
export const AHSAP_WIDTHS = [100, 125, 150, 175, 200, 225, 250, 275, 300, 325, 350, 375, 400];

export const AHSAP_PRICES = {
  alis:  [ 545,  681,  818,  954, 1090, 1226, 1363, 1499, 1635, 1771, 1908, 2044, 2180],
  satis: [1090, 1362, 1636, 1908, 2180, 2452, 2726, 2998, 3270, 3542, 3816, 4088, 4360],
};

export const AHSAP_RENKLER = [
  { kod: "Altın",      label: "Altın" },
  { kod: "Gümüş",     label: "Gümüş" },
  { kod: "Beyaz",      label: "Beyaz" },
  { kod: "Siyah",      label: "Siyah" },
  { kod: "Antrasit",   label: "Antrasit" },
  { kod: "Naturel",    label: "Naturel" },
  { kod: "Ceviz",      label: "Ceviz" },
  { kod: "Kızıl Meşe", label: "Kızıl Meşe" },
  { kod: "Meşe",       label: "Meşe" },
];

export const AHSAP_RAY_SATIS_BIRIM = 280;

// ─── ANTİK & RETRO ─────────────────────────────────────────────────────────────
export const ANTIK_WIDTHS = [100, 150, 200, 250, 300, 350, 400];
export const ANTIK_AYAK   = [  2,   2,   2,   3,   3,   4,   4];

export const ANTIK_PRICES = {
  "30mm": {
    label: "Çap 30",
    alis:  [1750, 2140, 3125, 3375, 3750, 4250, 4750],
    satis: [3500, 4280, 6250, 6750, 7500, 8500, 9500],
  },
  "40mm": {
    label: "Çap 40",
    alis:  [1875, 2500, 3250, 3500, 4000, 4375, 4875],
    satis: [3750, 5000, 6500, 7000, 8000, 8750, 9750],
  },
};

// ─── Fiyat Cetveli (SettingsPage) için ────────────────────────────────────────
export const KANALLI_WIDTHS = [100, 125, 150, 175, 200, 225, 250, 275, 300, 325, 350, 375, 400];
export const KANALLI_AYAK   = [  2,   2,   2,   3,   3,   3,   4,   4,   4,   4,   5,   5,   5];

export const KANALLI_PRICES = {
  tekli: {
    label: "Tekli (AK 1-2-3)",
    alis:  [ 990, 1040, 1090, 1340, 1390, 1440, 1690, 1740, 1790, 1840, 2090, 2140, 2190],
    satis: [1980, 2080, 2180, 2680, 2780, 2880, 3380, 3480, 3580, 3680, 4180, 4280, 4380],
  },
  ciftli: {
    label: "Çiftli (4-5-6-7)",
    alis:  [1430, 1530, 1630, 1960, 2060, 2160, 2490, 2590, 2690, 2790, 3120, 3220, 3320],
    satis: [2860, 3060, 3260, 3920, 4120, 4320, 4980, 5180, 5380, 5580, 6240, 6440, 6640],
  },
};

export const KANALLI_PARCA = [
  { key: "boru",       label: "Boru (20lik Kanallı)", birim: "MT",   alis: 200, satis: 400 },
  { key: "ayakTekli",  label: "Ayak Tekli",            birim: "ADET", alis: 200, satis: 400 },
  { key: "ayakCiftli", label: "Ayak Çiftli",           birim: "ADET", alis: 230, satis: 460 },
  { key: "baslik",     label: "Başlık Alüminyum",      birim: "ADET", alis: 195, satis: 390 },
  { key: "tapa",       label: "Tapa Başlık",           birim: "ADET", alis:  90, satis: 180 },
];

export const AHSAP_PARCA = [
  { key: "boru", label: "Boru Ø28 (tüm renkler)", birim: "MT", alis: 545, satis: 1090 },
  { key: "ray",  label: "Tekli Ray",               birim: "MT", alis: 140, satis:  280 },
];

export const ANTIK_PARCA = [
  { key: "ray", label: "Ray Kanallı", birim: "MT", alis: 275, satis: 550 },
];

// ─── Matris Lookup (Ahşap + Antik) ────────────────────────────────────────────

function findBracketIdx(widths, w) {
  if (w <= widths[0]) return 0;
  if (w > widths[widths.length - 1]) return -1;
  const idx = widths.findIndex(v => v >= w);
  return idx >= 0 ? idx : widths.length - 1;
}

export function lookupRustikPrice(tip, model, widthCm, rayDahil = false) {
  const w   = Number(widthCm) || 0;
  const wMt = w / 100;

  if (tip === "ahsap") {
    const idx = findBracketIdx(AHSAP_WIDTHS, w);
    if (idx < 0) return { outOfRange: true, alis: 0, satis: 0 };
    return {
      outOfRange: false,
      alis:  AHSAP_PRICES.alis[idx],
      satis: AHSAP_PRICES.satis[idx],
      widthUsed: AHSAP_WIDTHS[idx],
      ayak: null,
      rayEkAlis:  rayDahil ? Math.round(wMt * 140) : 0,
      rayEkSatis: rayDahil ? Math.round(wMt * AHSAP_RAY_SATIS_BIRIM) : 0,
    };
  }

  if (tip === "antik") {
    const variant = ANTIK_PRICES[model] || ANTIK_PRICES["30mm"];
    const idx = findBracketIdx(ANTIK_WIDTHS, w);
    if (idx < 0) return { outOfRange: true, alis: 0, satis: 0 };
    return {
      outOfRange: false,
      alis:  variant.alis[idx],
      satis: variant.satis[idx],
      widthUsed: ANTIK_WIDTHS[idx],
      ayak: ANTIK_AYAK[idx],
      rayEkAlis:  rayDahil ? Math.round(wMt * 275) : 0,
      rayEkSatis: rayDahil ? Math.round(wMt * 550) : 0,
    };
  }

  return { outOfRange: true, alis: 0, satis: 0 };
}
